import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal } from "react-bootstrap";
import moment from 'moment';
import BootstrapTable from 'react-bootstrap-table-next';
import { getCookie } from "../../../../services/helper/Helper";
import paginationFactory from 'react-bootstrap-table2-paginator';
import { downloadFiles } from '../../../../actions/docketGeneralInfoAction';
import {mediaPath } from "../../../../config";
import {getCurrentUserData} from "../../../../services/http-services/HttpServices";

class PendingRejectedDocuments extends Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			showInfoModal: false,
		};
		//let value=getCookie(btoa("publicAccess"));
		//this.userId = JSON.parse(atob(value)).user_id;
		this.userId = '';
		getCurrentUserData()
			.then(json => {
				this.userId = json.user_id;
			});
	}

	asyncCall = async () =>  {
		//console.log('calling');
		const result = await getCurrentUserData();
		//console.log(result,4500);
		return result;
	}

	componentDidMount = async () => {

			let userData = await this.asyncCall();
			//console.log(userData.user_id,6000);
			this.userId = userData.user_id;
	}

	handleShow() {
			this.setState({ showInfoModal: true });
	}
	handleClose() {
		this.setState({ showInfoModal: false });
	}

	render() {
		const options = {
		// pageStartIndex: 0,
		  sizePerPage: 10,
		  hideSizePerPage: true,
		  firstPageText: 'First',
		  prePageText: 'Prev',
		  nextPageText: 'Next',
		  lastPageText: 'Last',
		  hidePageListOnlyOnePage: true
    };
		const externalDocs = this.props.docketGeneralInfo.externalDocuments  || [];
		// function dateFormatter(cell: any) {
			// if (!cell) {
				// return "";
			// }
			// return (moment(new Date(cell).toLocaleDateString()).format("MM-DD-YYYY"));
		// }
		
		const documents = [
			{
				dataField: 'document_type',

				text: 'Document Type ',
				sort: true,
				headerClasses: 'document',
				classes: 'document',
				sortCaret: (order, column) => {
					return (!order || order === 'desc') ?  <i className="fa fa-angle-down"></i> : <i className="fa fa-angle-up"></i>;
				}

			},
			{
				dataField: 'document_name',

				text: 'Document Name  ',
				sort: true,
				headerClasses: 'name',
				classes: 'name',
				sortCaret: (order, column) => {
					return (!order || order === 'desc') ?  <i className="fa fa-angle-down"></i> : <i className="fa fa-angle-up"></i>;
				}

			},
			{
				dataField: 'date_submitted',

				text: 'Date Submitted  ',
				sort: true,
				headerClasses: 'date',
				classes: 'date',
				sortCaret: (order, column) => {
					return (!order || order === 'desc') ?  <i className="fa fa-angle-down"></i> : <i className="fa fa-angle-up"></i>;
				}
			},
			{
				dataField: 'status',

				text: 'Status ',
				sort: true,
				headerClasses: 'status',
				classes: 'status',
				sortCaret: (order, column) => {
					return (!order || order === 'desc') ?  <i className="fa fa-angle-down"></i> : <i className="fa fa-angle-up"></i>;
				}
			},
			{
				dataField: 'description',

				text: 'Description ',
				sort: true,
				headerClasses: 'desc',
				classes: 'desc',
				sortCaret: (order, column) => {
					return (!order || order === 'desc') ?  <i className="fa fa-angle-down"></i> : <i className="fa fa-angle-up"></i>;
				},
			},
			{
				dataField: 'rejected_reason',

				text: 'Reason for Rejection ',
				sort: true,
				headerClasses: 'rejection',
				classes: 'rejection',
				sortCaret: (order, column) => {
					return (!order || order === 'desc') ?  <i className="fa fa-angle-down"></i> : <i className="fa fa-angle-up"></i>;
				},
			},
			{
				headerClasses: 'icon',
				classes: 'icon',
				dataField: 'Download',
				text: '',
				formatter: (value, row) => {
					return (row.created_by==this.userId && row.is_file_scaned=='1') ? 
						<a href="javascript:;" onClick={() => this.props.downloadFiles(row.document_id, '1','external')}><i aria-label="Download document" className="fa fa-download" ></i><span>Download</span></a> : '-'
					},	

			},
			
			{
				headerClasses: 'icon',
				classes: 'icon',
				dataField: 'Info',
				text: '',
				formatter: (value, row) => {
					return (row.created_by!=this.userId && row.is_file_scaned=='1') ? 
						<a href="javascript:;"><i aria-label="Document info" className="fa fa-info-circle" onClick={() => { this.handleShow("info") }}></i></a> : '-'
					},	

			},
		];
		const defaultDocumentSorted = [{
			dataField: 'date_submitted',
			order: 'desc'
		}];

		return (
			<div>
				<div className="pending-or-reject-document-block">
					<div className="pending-or-reject-document-inner-block">
						<div className="container">
							<div className="col-xs-12">
								<h1 className="title">Pending or Rejected Documents</h1>
							</div>
							<div className="col-xs-12">
								<div className="pending-or-reject-document-table">
									<BootstrapTable wrapperClasses="boo" keyField='document_id' data={externalDocs} columns={documents} defaultSorted={defaultDocumentSorted} pagination={ paginationFactory(options) } noDataIndication={'No records found.'} bordered={false} />
								</div>
							</div>
						</div>
					</div>  
				</div>
				<Modal show={this.state.showInfoModal}
						onHide={() => this.handleClose()}
						backdrop="static" id="doc-thankyou"
						className="modal fade">
						<Modal.Header>
							<button type="button" onClick={() => this.handleClose("info")} className="close" data-dismiss="modal">
								<img src={mediaPath+"close.png"} alt="close" />
							</button>
						</Modal.Header>
						<Modal.Body>
							<div className="row">
								<div className="col-xs-12">
									<h2>Contact Info</h2>
								</div>
							</div>
							<div className="row">
								<div className="col-xs-12">
									<p className="note">Contact OSAH at publicportal@osah.ga.gov for questions.</p>
								</div>
							</div>
						</Modal.Body>
						<Modal.Footer>
							<div className="btn-block">
								<button type="button" onClick={() => this.handleClose("info")} className="btn cancel">Close Window</button>
							</div>
						</Modal.Footer>
					</Modal>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		docketGeneralInfo: state.docketGeneralInfo,
	};
}

export default connect(mapStateToProps, { downloadFiles })(PendingRejectedDocuments);